export const events = {
  eventsCardDurationText: 'trvání',
  eventsSearchInputText: 'Hledat',
  eventsRegisteredToEventAlertTitle: 'Úspěšně registrováno',
  eventsUnregisteredToEventAlertTitle: 'Úspěšně odregistrováno',
  eventsExternalRegistrationPopupTitle: 'Registrace',
  eventsExternalRegistrationPopupContent: 'Úspěšně jste se registroval(a)?',
  eventsExternalRegistrationNoButtonTitle: 'Ne',
  eventsExternalRegistrationYesButtonTitle: 'Ano',
  eventsCurtainCopyOptionTitle: 'Kopírovat odkaz',
  eventsCurtainFlagOptionTitle: 'Nahlásit obsah',
  eventsLinkCopiedAlertText: 'Odkaz zkopírován!',
  eventsCurtainAddToCalendOptionTitle: 'Přidat do kalendáře',
  eventdetailsAgendaButtonTitle: 'Program',
  eventdetailsOnMapButtonTitle: 'Na mapě',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Účastníci',
  eventdetailsSeeAllButtonTitle: 'Zobrazit vše',
  eventdetailsRegisteredButtonTitle: 'Registrováno',
  eventdetailsRegisterButtonTitle: 'Registrovat',
  eventdetailsRegisteredAlertText: 'Úspěšně registrováno',
  eventdetailsUnregisteredAlertText: 'Úspěšně odregistrováno',
  eventdetailsAgendaTitle: 'Program',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Registrovaní uživatelé',
  eventdetailsSpeakersCurtainTitle: 'Mluvčí',
  eventdetailsSpeakersSectionTitle: 'Mluvčí',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Zobrazit vše',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Zobrazit vše',
  eventdetailsCurtainCopyOptionTitle: 'Kopírovat odkaz',
  eventdetailsCurtainFlagOptionTitle: 'Nahlásit obsah',
  eventsdetailsLinkCopiedAlertText: 'Odkaz zkopírován!',
  eventdetailsCurtainAddToCalOptionTitle: 'Přidat do kalendáře',
  eventDetailsAddCalendarPopupTitle: 'Kalendář',
  eventdetailsAddCalendarPopupContent: 'Přidat do kalendáře?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Ne',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Ano',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Kopírovat odkaz',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Nahlásit obsah',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Odkaz zkopírován!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Kopírovat odkaz',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Nahlásit obsah',
  eventsFlag: 'Nahlásit',
  eventsJoin: 'Připojit se',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Odkaz zkopírován!',
  eventContentReported: 'Obsah nahlášen',
  eventsError: 'Něco se pokazilo!',
  eventdetailsExternalRegistrationPopupContent: 'Úspěšně jste se registroval(a)?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Ne',
  eventdetailsExternalRegistrationYesButtonTitle: 'Ano',
  eventdetailsExternalRegistrationPopupTitle: 'Registrace',
  eventsCardRegisteredButtonTitle: 'Registrováno',
  eventsCardRegisterButtonTitle: 'Registrovat',
  eventsJoinLink: 'Odkaz k připojení: [url]{link}[/url][br]',
  eventsGuest: 'Host',
  eventsNoSessionInDay: 'Tento den žádné události.',
  eventsShowUpcomingEvent: 'Zobrazit nadcházející událost'
}
